var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link",class:("tc-" + _vm.color + " link--" + _vm.modifier),attrs:{"href":_vm.R[_vm.link.key]}},[_c('span',[_vm._v(_vm._s(_vm.link.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }